import React, { useEffect } from "react";

/**
 * IntersectionObserver based reveal hook.
 * Adds `is-visible` class to elements with `.ssh-reveal` when they enter viewport.
 */
export default function useReveal() {
    useEffect(() => {
        const els = document.querySelectorAll(".ssh-reveal");
        if (!els.length) return;
        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((e) => {
                    if (e.isIntersecting) {
                        e.target.classList.add("is-visible");
                        io.unobserve(e.target);
                    }
                });
            },
            { threshold: 0.12 },
        );
        els.forEach((el) => io.observe(el));
        return () => io.disconnect();
    }, []);
}
